import { z } from 'zod';

const requiredStringSchema = z.string().min(1);

export const idNameSchema = z.object({
  Id: requiredStringSchema,
  Name: requiredStringSchema
});

export const idNameArraySchema = z.array(idNameSchema);

export const idNameArrayApiResponseSchema = z.object({
  Data: idNameArraySchema
});

export type IdName = z.infer<typeof idNameSchema>;
export type IdNameArray = z.infer<typeof idNameArraySchema>;
export type IdNameArrayApiResponse = z.infer<typeof idNameArrayApiResponseSchema>;
